/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */

import React, { useContext, useEffect, useRef, useState } from "react";
import * as Sentry from "@sentry/react";
import { EVENT_NAME } from "../Components/constant";
import useParamsQuery from "../Components/hooks/useParamsQuery";
import { isEmptyObj } from "../Components/helper";
import styles from "./ContributionComparisonReport.styles";
import OrganizationStructure from "./Components/OrganizationStructureNew/OrganizationStructure";
import Popover from "../Components/Popover/NewPopover";
import { getFilters } from "./utils";
import { SERVICES } from "../../../components/Layout/Services";
import Loader from "../../../components/Loader/Loader";
import SearchIconWithPeople from "../../../components/Svg/SearchIconWithPeople";
import EmptyFileIcon from "../../../components/Svg/EmptyFile";
import PageSyncCal from "../../../components/Layout/PageSyncCal";
import Heading from "../../../components/Layout/Heading";
import { OuterContainerStyles } from "../../../components/Layout/Typography";
import { get } from "../../../components/Layout/ApiHandler/apihandler";
import Button from "../../../components/Layout/Button";
import AutoCompleteDropdown from "../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import GenericTable from "./Components/GenericTable";
import { ToastAlertContext } from "../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../contants";

const tableHeaders = [
  "S.No.",
  "Area",
  "Zone",
  "No of members",
  "First Cycle",
  "Second Cycle",
  "Member Difference",
  "Amount Difference",
];
const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));

function ContributionComparisonReport() {
  const [searchData, setSearchData] = useState([]);
  const [data, setData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [currentPage, setCurrentPage] = useState(0);

  const [values, setValues] = useState({
    areaId: null,
    zoneId: null,
    regionId: null,
    chapterId: null,
    districtId: null,
    blockId: null,
  });

  const [cycle1, setCycle1] = useState([]);
  const [selectedCycle1, setSelectedCycle1] = useState("");
  const [cycle2, setCycle2] = useState([]);
  const [selectedCycle2, setSelectedCycle2] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);
  const toast = useContext(ToastAlertContext);

  const handleCycle1 = async () => {
    try {
      const url = `${SERVICES.GET_CONTRIBUTION_CYCLE}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setCycle1(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleCycle2 = async () => {
    try {
      const url = `${SERVICES.GET_CONTRIBUTION_CYCLE}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setCycle2(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    handleCycle1();
    handleCycle2();
  }, []);

  const updateOrganizationStructureValues = (updatedValues) => {
    // console.log(updatedValues);
    setValues(updatedValues);
  };

  const constructQueryParameters = (cycle1, cycle2) => {
    const queryParams = [];
    const optionalParams = {
      areaId: values.areaId,
      zoneId: values.zoneId,
      regionId: values.regionId,
      chapterId: values.chapterId,
      districtId: values.districtId,
    };
    for (const key in optionalParams) {
      if (optionalParams[key] !== null && optionalParams[key] !== undefined) {
        queryParams.push(`${key}=${optionalParams[key]}`);
      }
    }
    if (cycle1) {
      queryParams.push(`firstCycleId=${selectedCycle1}`);
    }
    if (cycle2) {
      queryParams.push(`secondCycleId=${selectedCycle2}`);
    }
    return queryParams.join("&");
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    setSearchPerformed(true);
    if (!values.areaId) {
      toast.show("Please select area", AlertStatus.ERROR);
      return;
    }
    try {
      setIsLoading(true);
      const url = `${
        SERVICES.GET_CONTRIBUTION_COMPARISON_REPORTS
      }?${constructQueryParameters(selectedCycle1, selectedCycle2)}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setSearchData(data.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
    // finally{
    //   setIsLoading(false);
    // }
    document.dispatchEvent(new Event(EVENT_NAME));
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    try {
      const url = `${
        SERVICES.GET_CONTRIBUTION_COMPARISON_REPORTS
      }?${constructQueryParameters()}&pageNumber=${selectedPage}&pageSize=${10}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setSearchData(data.data);
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (searchData) {
      const updatedTableData = searchData.map((item, index) => {
        const firstCycleContributedMembers =
          item?.firstCycle?.contributedMembers ?? 0;
        const firstCycleAmount = item?.firstCycle?.amount ?? 0;
        const secondCycleContributedMembers =
          item?.secondCycle?.contributedMembers ?? 0;
        const secondCycleAmount = item?.secondCycle?.amount ?? 0;
        const memberDiff = item?.contributedMemberDiff ?? 0;
        const amountDiff = item?.amountDiff ?? 0;
        const serialNumber = currentPage * 10 + index + 1;

        return {
          "S.No.": serialNumber,
          Area: item?.areaName,
          Zone: item?.zoneName,
          "No of members": item?.totalMembers,
          "First Cycle": {
            name: item?.firstCycle?.name,
            contributedMembers: firstCycleContributedMembers,
            amount: firstCycleAmount,
          },
          "Second Cycle": {
            name: item?.secondCycle?.name,
            contributedMembers: secondCycleContributedMembers,
            amount: secondCycleAmount,
          },
          "Member Difference": memberDiff,
          "Amount Difference": amountDiff,
        };
      });

      setData(updatedTableData);
    }
  }, [searchData]);
  // console.log(data);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setAppliedFilters(getFilters(query));
    }
  }, [urlSearchParams.toString()]);

  return (
    <div style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
      <PageSyncCal />
      <Heading title="Contribution Comparison Report" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <div style={styles.container}>
          <div style={styles.filter}>
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              <AutoCompleteDropdown
                getOptionLabel={(option) => option.name}
                options={getOptions(cycle1, "id")}
                label="Contribution Cycle 1"
                name="cycle1"
                value={selectedCycle1}
                onChange={(selectedValue) => {
                  setSelectedCycle1(selectedValue?.value);
                }}
                inputProps={{ required: true }}
                useHiddenInput
                style={{ width: "12rem" }}
              />
              <AutoCompleteDropdown
                getOptionLabel={(option) => option.name}
                options={getOptions(cycle2, "id")}
                label="Contribution Cycle 2"
                name="cycle2"
                value={selectedCycle2}
                onChange={(selectedValue) => {
                  setSelectedCycle2(selectedValue?.value);
                }}
                inputProps={{ required: true }}
                useHiddenInput
                style={{ width: "12rem" }}
              />
              <Popover heading="Organization Structure" minWidth={413}>
                <OrganizationStructure
                  onUpdateValues={updateOrganizationStructureValues}
                />
              </Popover>
              <Button type="submit">Search</Button>
            </form>
          </div>
          <div style={styles.main}>
            {!searchPerformed ? (
              <div style={styles.initialContent}>
                <SearchIconWithPeople width={100} />
                <span style={styles.text}>Choose your Search Filter</span>
              </div>
            ) : data?.length > 0 ? (
              <div>
                <GenericTable
                  tableData={data}
                  data={searchData}
                  headers={tableHeaders}
                  onPageChange={handlePageChange}
                />
              </div>
            ) : (
              <div style={styles.initialContent}>
                <EmptyFileIcon width={100} />
                <span style={styles.text}>
                  No data found with current Filters
                </span>
              </div>
            )}
          </div>
          {isLoading && <Loader />}
        </div>
      </OuterContainerStyles>
    </div>
  );
}
export default ContributionComparisonReport;
